
(function(){
  // ---------- helpers ----------
  const qs = (sel, root=document) => root.querySelector(sel);
  const drawer = qs('#VQCartDrawer');
  const overlay = qs('#VQCartDrawerOverlay');
  const fab = qs('#VQShoppingListFab');
  if (!drawer || !overlay) return;

  if (fab) {
    fab.addEventListener('click', () => {
      if (window.VQCartDrawer && typeof window.VQCartDrawer.openAndRefresh === 'function') {
        window.VQCartDrawer.openAndRefresh();
      } else {
        document.dispatchEvent(new CustomEvent('vq:cart:open'));
      }
    });
  }

  const linesRoot = qs('[data-vq-lines]', drawer);
  const subtotalEl = qs('[data-vq-subtotal]', drawer);
  const studioHelper = qs('[data-vq-studio-helper]', drawer);
  const cartMessage = qs('[data-vq-cart-message]', drawer);
  const savedPanel = qs('[data-vq-saved-panel]', drawer);
  const savedList = qs('[data-vq-saved-list]', drawer);
  const savedOpenBtn = qs('[data-vq-saved-open]', drawer);
  const savedBackBtn = qs('[data-vq-saved-back]', drawer);
  const savedCountEls = Array.from(drawer.querySelectorAll('[data-vq-saved-count]'));
  const SAVED_DESIGNS_KEY = 'stc.savedDesigns.v1';

  const readSavedDesigns = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(SAVED_DESIGNS_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch(e) {
      return [];
    }
  };

  const writeSavedDesigns = (designs) => {
    try {
      window.localStorage.setItem(SAVED_DESIGNS_KEY, JSON.stringify(designs));
      document.dispatchEvent(new CustomEvent('stc:saved-designs:changed', { detail: { designs } }));
      return true;
    } catch(e) {
      return false;
    }
  };

  const escHtml = (v) => String(v == null ? '' : v)
    .replace(/&/g,'&amp;')
    .replace(/</g,'&lt;')
    .replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;')
    .replace(/'/g,'&#039;');

  const renderSavedDesigns = () => {
    const designs = readSavedDesigns();
    savedCountEls.forEach(el => { el.textContent = String(designs.length); });

    if (!savedList) return;
    if (!designs.length) {
      savedList.innerHTML = '<div class="vqcd__saved-empty">No designs saved yet.<br>Browse the Design Library and choose <strong>Save Design</strong>.</div>';
      return;
    }

    savedList.innerHTML = designs.map((design) => `
      <article class="vqcd__saved-item" data-vq-saved-id="${escHtml(design.id)}">
        ${design.previewUrl ? `<img class="vqcd__saved-img" src="${escHtml(design.previewUrl)}" alt="">` : '<div class="vqcd__saved-img"></div>'}
        <div>
          <div class="vqcd__saved-name">${escHtml(design.name || design.id)}</div>
          ${design.category ? `<div class="vqcd__saved-category">${escHtml(design.category)}</div>` : ''}
        </div>
        <button type="button" class="vqcd__saved-remove" data-vq-saved-remove>Remove</button>
      </article>
    `).join('');
  };

  const openSavedView = () => {
    if (!savedPanel) return;
    renderSavedDesigns();
    savedPanel.inert = false;
    savedPanel.dataset.open = 'true';
    Array.from(drawer.children).filter(node => node !== savedPanel).forEach(node => node.inert = true);
    savedPanel.setAttribute('aria-hidden','false');
    const back = qs('[data-vq-saved-back]', savedPanel);
    if (back) back.focus({preventScroll:true});
  };

  const closeSavedView = () => {
    if (!savedPanel) return;
    const restoreFocus = savedPanel.contains(document.activeElement);
    savedPanel.inert = true;
    savedPanel.dataset.open = 'false';
    Array.from(drawer.children).filter(node => node !== savedPanel).forEach(node => node.inert = false);
    if (restoreFocus && drawer.dataset.open === 'true' && savedOpenBtn) savedOpenBtn.focus({preventScroll:true});
    savedPanel.setAttribute('aria-hidden','true');
  };

  const formatMoney = (cents) => {
    try {
      // Use Shopify money format if present
      const fmt = (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney : null;
      if (fmt) return Shopify.formatMoney(cents);
    } catch(e) {}
    // Fallback USD-ish
    return (cents/100).toLocaleString(undefined, {style:'currency', currency:(window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'USD'});
  };

  const escAttr = (v) => {
    if (v == null) return '';
    return String(v)
      .replace(/&/g,'&amp;')
      .replace(/"/g,'&quot;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;');
  };

  
  const getProp = (props, keys) => {
    if (!props) return '';
    for (const k of keys) {
      if (Object.prototype.hasOwnProperty.call(props, k) && props[k] != null && String(props[k]).trim() !== '') return String(props[k]);
    }
    return '';
  };

  const cleanPersonalizationValue = (value) => {
    const s = String(value == null ? '' : value).trim();
    if (!s || s === '-' || s === '—' || s === '–' || /^n\/a$/i.test(s)) return '';
    return s;
  };

  const personalizationDetails = item => ({
    text: cleanPersonalizationValue(getProp(item?.properties, ['Personalization • Text','Text','Personalization text','Personalization Text','Engraving Text','What do you want it to say:','What do you want it to say']))
  });

  let templateRequirements = new Map();
  const isCustomizable = (item) => templateRequirements.get(String(item.product_id)) === 'customized';

  const readTemplateRequirements = (cart, signal) => window.STCCartReadiness.requirements(cart, signal);
  const hasComplete = item => window.STCCartReadiness.hasComplete(item);

  const isReady = (item) => {
    if (isCustomizable(item)) return hasComplete(item);
    return true;
  };

// Scroll lock to prevent background page from scrolling while drawer is open.
// This avoids accidental drawer-close triggers caused by window scroll when the user scrolls over the drawer.
const _vqScrollLock = (() => {
  let locked = false;
  let scrollY = 0;
  return {
    isLocked: () => locked,
    lock: () => {
      if (locked) return;
      locked = true;
      scrollY = window.scrollY || 0;
      document.documentElement.dataset.vqScrollLock = 'true';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    },
    unlock: () => {
      if (!locked) return;
      locked = false;
      document.documentElement.dataset.vqScrollLock = 'false';
      const top = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      const y = top ? Math.abs(parseInt(top, 10)) : scrollY;
      window.scrollTo(0, y);
    }
  };
})();

let returnFocus = null;
  const backgroundInert = new Map();
  const setOpen = (opening) => {
    const wasOpen = drawer.dataset.open === 'true';
    if (opening && !wasOpen) {
      returnFocus = document.activeElement;
      Array.from(document.body.children).forEach(node => {
        if (node === drawer || node === overlay || node.tagName === 'SCRIPT' || node.tagName === 'STYLE' || node.tagName === 'LINK') return;
        backgroundInert.set(node, node.inert);
        node.inert = true;
      });
    }
    drawer.inert = !opening;
    drawer.setAttribute('aria-hidden', String(!opening));
    drawer.dataset.open = opening ? 'true' : 'false';
    overlay.dataset.open = opening ? 'true' : 'false';
    if (opening) _vqScrollLock.lock(); else _vqScrollLock.unlock();
    if (fab) fab.hidden = opening;
    if (opening && !wasOpen) drawer.focus({preventScroll:true});
    if (!opening && wasOpen) {
      backgroundInert.forEach((value,node) => { node.inert = value; });
      backgroundInert.clear();
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
    }
  };

  const close = () => { closeSavedView(); setOpen(false); };

  const open = () => setOpen(true);
  // Close drawer when user scrolls outside of it (wheel/touch). 
  // Important: avoid false positives when cursor is over the drawer but the event target is odd (e.g., overlay).
  const isDrawerOpen = () => drawer.dataset.open === 'true';
  const isPointInsideDrawer = (clientX, clientY) => {
    try {
      const el = document.elementFromPoint(clientX, clientY);
      return !!(el && drawer.contains(el));
    } catch (e) { return false; }
  };

  const onWheelOutside = (e) => {
    if (!isDrawerOpen()) return;
    // If the pointer position is inside the drawer, do nothing.
    const x = (typeof e.clientX === 'number') ? e.clientX : 0;
    const y = (typeof e.clientY === 'number') ? e.clientY : 0;
    if (isPointInsideDrawer(x, y)) return;

    // Also respect composedPath in case elementFromPoint is unreliable.
    if (e.composedPath && e.composedPath().includes(drawer)) return;

    close();
    // Prevent page scroll "jump" behind the overlay if scroll lock fails on some browsers.
    e.preventDefault();
  };

  // Use capture so we can intercept before the page scrolls.
  document.addEventListener('wheel', onWheelOutside, { passive: false, capture: true });

  // Touch devices: if touchmove occurs outside the drawer while open, close.
  let _vqTouchStartedInsideDrawer = false;
  document.addEventListener('touchstart', (e) => {
    if (!isDrawerOpen()) return;
    const t = e.touches && e.touches[0];
    if (!t) return;
    _vqTouchStartedInsideDrawer = isPointInsideDrawer(t.clientX, t.clientY) || (e.composedPath && e.composedPath().includes(drawer));
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', (e) => {
    if (!isDrawerOpen()) return;
    if (_vqTouchStartedInsideDrawer) return;
    const t = e.touches && e.touches[0];
    if (!t) return;
    if (isPointInsideDrawer(t.clientX, t.clientY)) return;
    close();
    e.preventDefault();
  }, { passive: false, capture: true });

  renderSavedDesigns();

  let _vqRefreshSeq = 0;
  let _vqRefreshController = null;

  const setCartMessage = (message = '') => {
    if (!cartMessage) return;
    cartMessage.textContent = message;
    cartMessage.hidden = !message;
  };

  const renderCartError = (error) => {
    console.error('[VQ] Shopping List render failed', error);
    if (studioHelper) studioHelper.hidden = true;
    if (linesRoot) linesRoot.innerHTML = '';
    if (subtotalEl) subtotalEl.textContent = '—';
    const checkoutBtn = qs('[data-vq-checkout]', drawer);
    const checkoutNote = qs('[data-vq-checkout-note]', drawer);
    if (checkoutBtn) {
      checkoutBtn.setAttribute('aria-disabled', 'true');
      checkoutBtn.setAttribute('tabindex', '-1');
      checkoutBtn.classList.remove('vqcd__btn--checkout-ready');
    }
    if (checkoutNote) checkoutNote.hidden = true;
    setCartMessage('We could not load your Shopping List. Please try again.');
  };

  // Initial refresh: keep FAB state (Checkout vs Shopping List) in sync on every page load
  // without forcing the drawer to open.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh);
  } else {
    refresh();
  }


  async function refresh(){
    const requestId = ++_vqRefreshSeq;
    if (_vqRefreshController) _vqRefreshController.abort();
    _vqRefreshController = new AbortController();
    try {
      const res = await fetch(window.STCCartReadiness.route('/cart.js'), {credentials:'same-origin', signal:_vqRefreshController.signal});
      if (!res.ok) throw new Error('cart.js failed');
      const cart = await res.json();
      const requirements = await readTemplateRequirements(cart, _vqRefreshController.signal);
      if (requestId !== _vqRefreshSeq) return;
      templateRequirements = requirements;
      document.dispatchEvent(new CustomEvent('stc:cart:readiness', {detail:{ready:window.STCCartReadiness.ready(cart,requirements), count:Number(cart.item_count || 0)}}));
      setCartMessage('');

      // Notify other surfaces (e.g., Personalization Studio) when the cart changes
      // so they can prompt the user to refresh while remaining deterministic.
      // We intentionally do NOT fire on the first refresh to avoid a false "changed" cue.
      try{
        window.__vqCartDrawer = window.__vqCartDrawer || {};
        const sig = JSON.stringify({
          c: Number(cart.item_count || 0),
          t: Number(cart.total_price || 0),
          k: (cart.items || []).map(i => String(i.key || '')).join('|')
        });
        const first = window.__vqCartDrawer.__firstRefreshDone !== true;
        const prev = window.__vqCartDrawer.__lastSig || '';
        window.__vqCartDrawer.__firstRefreshDone = true;
        window.__vqCartDrawer.__lastSig = sig;
        if(!first && sig !== prev){
          document.dispatchEvent(new CustomEvent('vq:cart:updated', { detail: { source: 'drawer' } }));
        }
      }catch(e){}

      // Keep Dawn's header bubble in sync (even though VQ is the primary surface).
      try {
        let bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        const icon = document.getElementById('cart-icon-bubble');
        const count = Number(cart.item_count || 0);

        if (icon) {
          // If the theme rendered with an empty cart, the bubble may not exist yet.
          if (!bubble && count > 0) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = `<span aria-hidden="true"></span><span class="visually-hidden"></span>`;
            icon.appendChild(bubble);
          }
          // Update the visible count if present
          if (bubble) {
            const ariaSpan = bubble.querySelector('.visually-hidden');
            const countSpan = bubble.querySelector('span[aria-hidden="true"]');
            if (countSpan) countSpan.textContent = String(Math.min(count, 99));
            if (ariaSpan) ariaSpan.textContent = count === 1 ? '1 item' : `${count} items`;
            bubble.style.display = count > 0 ? '' : 'none';
          }
        }
      } catch(e) {}

      if (!linesRoot) return;

      if (!cart.items || cart.items.length === 0) {
        const checkout = qs('[data-vq-checkout]', drawer);
        if (checkout) {
          checkout.setAttribute('aria-disabled','true');
          checkout.setAttribute('tabindex','-1');
          checkout.classList.remove('vqcd__btn--checkout-ready');
        }
        const studio = qs('[data-vq-to-studio]', drawer);
        if (studio) studio.hidden = true;
        const note = qs('[data-vq-checkout-note]', drawer);
        if (note) note.hidden = true;
        if (studioHelper) studioHelper.hidden = true;
        linesRoot.innerHTML = '<div class="vqcd__disclaimer">Your cart is empty.</div>';
        if (subtotalEl) subtotalEl.textContent = formatMoney(0);
        return;
      }


      if(studioHelper)studioHelper.hidden=true;
      const studioBtn=qs('[data-vq-to-studio]',drawer);if(studioBtn)studioBtn.hidden=true;
      const checkoutNote=qs('[data-vq-checkout-note]',drawer);if(checkoutNote)checkoutNote.hidden=true;
      linesRoot.innerHTML=cart.items.map(item=>{
        const custom=isCustomizable(item),image=item.featured_image?.url||'';
        const summary=personalizationDetails(item);
        const excerpt=String(summary.text||'').replace(/\s+/g,' ').trim().slice(0,100);
        const editUrl=(window.Shopify?.routes?.root||'/')+'pages/personalization-studio?ob_edit='+encodeURIComponent(item.key)+'';
        return '<section class="vqcd__line" style="display:flex;gap:12px;padding:16px 0">'+(image?'<img src="'+escAttr(image)+'" alt="" width="56" height="56" style="object-fit:contain">':'')+'<div style="flex:1;min-width:0"><strong>'+escHtml(item.product_title||item.title)+'</strong><p>'+escHtml(item.variant_title||'')+' · Quantity '+Number(item.quantity)+'</p>'+(custom?'<p>'+(isReady(item)?'Personalization added':'Personalization needed')+'</p>'+(excerpt?'<p>'+escHtml(excerpt)+'</p>':'')+'<a href="'+escAttr(editUrl)+'">Edit personalization</a>':'')+'</div><strong>'+formatMoney(item.final_line_price||0)+'</strong></section>';
      }).join('');

      // Keep the subtotal aligned with the visible line-item totals. Discounts
      // remain a checkout concern so the Shopping List stays clear and predictable.
      const subtotal = Number(
        cart.items_subtotal_price != null
          ? cart.items_subtotal_price
          : (cart.items || []).reduce((sum, item) => sum + Number(item.final_line_price || 0), 0)
      );

      if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    } catch(e){
      if (e && e.name === 'AbortError') return;
      if (requestId !== _vqRefreshSeq) return;
      renderCartError(e);
    } finally {
      if (requestId === _vqRefreshSeq) _vqRefreshController = null;
    }
  }

  // Final checkout cleanup: remove workflow-only replacement metadata while
  // preserving production-facing personalization, artwork, and stable group IDs.
  const VQ_TEMP_CHECKOUT_PROPERTIES = ['_ps_tx','_ps_replace_id','_Replace key','_ps_planned'];
  async function finalizeCartMetadataForCheckout(){
    const response=await fetch(window.STCCartReadiness.route('/cart.js'),{credentials:'same-origin'});
    if(!response.ok) throw new Error('Could not prepare the cart for checkout.');
    const cart=await response.json();
    const requirements=await readTemplateRequirements(cart);
    if (!window.STCCartReadiness.ready(cart,requirements)) throw new Error('Your Shopping List changed. Finish personalization before checkout.');

    const updates=(cart.items||[]).map((item,index)=>{
      const properties={...(item.properties||{})};
      let changed=false;
      VQ_TEMP_CHECKOUT_PROPERTIES.forEach(key=>{
        if(Object.prototype.hasOwnProperty.call(properties,key)){
          delete properties[key];
          changed=true;
        }
      });
      if(!cleanPersonalizationValue(properties['_ps_plan_parent']) && Object.prototype.hasOwnProperty.call(properties,'_ps_style')){
        delete properties._ps_style;
        changed=true;
      }
      return changed ? {
        line:index+1,
        quantity:Number(item.quantity||1),
        properties
      } : null;
    }).filter(Boolean).sort((a,b)=>b.line-a.line);

    for(const update of updates){
      const changeResponse=await fetch(window.STCCartReadiness.route('/cart/change.js'),{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        body:JSON.stringify(update)
      });
      if(!changeResponse.ok) throw new Error('Could not finish preparing the cart for checkout.');
    }
  }

  // ---------- shared line item controls (Shopping List + Personalization Studio) ----------
  if (savedOpenBtn) savedOpenBtn.addEventListener('click', openSavedView);
  if (savedBackBtn) savedBackBtn.addEventListener('click', closeSavedView);

  if (savedList) {
    savedList.addEventListener('click', (e) => {
      const removeBtn = e.target && e.target.closest ? e.target.closest('[data-vq-saved-remove]') : null;
      if (!removeBtn) return;
      const item = removeBtn.closest('[data-vq-saved-id]');
      const id = item ? item.getAttribute('data-vq-saved-id') : '';
      if (!id) return;

      const next = readSavedDesigns().filter(design => String(design.id) !== String(id));
      if (writeSavedDesigns(next)) renderSavedDesigns();
    });
  }

  document.addEventListener('stc:saved-designs:changed', renderSavedDesigns);
  window.addEventListener('storage', (e) => {
    if (e.key === SAVED_DESIGNS_KEY) renderSavedDesigns();
  });

  let pendingAddOpen = null;
  let lastOpenAt = 0;
  const scheduleAddOpen = () => {
    clearTimeout(pendingAddOpen);
    pendingAddOpen = setTimeout(() => {
      pendingAddOpen = null;
      if (Date.now() - lastOpenAt > 500 && !window.__stcPsCartTransaction) window.VQCartDrawer.openAndRefresh();
    }, 200);
  };

  // Public API
  window.VQCartDrawer = window.VQCartDrawer || {};
  window.VQCartDrawer.openAndRefresh = async function(){
    clearTimeout(pendingAddOpen);
    lastOpenAt = Date.now();
    open();
    await refresh();
  };
  window.VQCartDrawer.refresh = refresh;
  window.VQCartDrawer.close = close;
  document.addEventListener('vq:cart:refresh', () => { refresh(); });


  // Close interactions
  drawer.addEventListener('click', (e) => {
    const t = e.target;
    if (t && t.matches && t.matches('[data-vq-close]')) {
      closeSavedView();
      close();
    }
  });
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (drawer.dataset.open !== 'true') return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    const scope = savedPanel && savedPanel.dataset.open === 'true' ? savedPanel : drawer;
    const focusable = Array.from(scope.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(node => !node.disabled && node.tabIndex >= 0 && !node.closest('[inert]') && node.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) { e.preventDefault(); drawer.focus(); return; }
    if (e.shiftKey && (document.activeElement === first || document.activeElement === drawer)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !scope.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });
  // Auto-close drawer on page scroll or clicking outside the drawer
  let _vqLastScrollY = window.scrollY || 0;
  window.addEventListener('scroll', () => {
    if (drawer.dataset.open !== 'true') { _vqLastScrollY = window.scrollY || 0; return; }
    const y = window.scrollY || 0;
    if (_vqScrollLock && _vqScrollLock.isLocked && _vqScrollLock.isLocked()) { _vqLastScrollY = y; return; }
    if (Math.abs(y - _vqLastScrollY) > 2) close();
    _vqLastScrollY = y;
  }, { passive: true });

  document.addEventListener('pointerdown', (e) => {
    if (drawer.dataset.open !== 'true') return;
    const t = e.target;
    if (drawer.contains(t)) return;
    if (fab && fab.contains(t)) return;
    // Overlay clicks already close; this ensures any click on the page outside closes too.
    close();
  }, true);


  // vq:cart:open event (used by Personalization Studio "Shopping List")
  document.addEventListener('vq:cart:open', () => {
    if (window.VQCartDrawer && typeof window.VQCartDrawer.openAndRefresh === 'function') {
      window.VQCartDrawer.openAndRefresh();
    }
  });

  // Header cart icon should open VQ (stay on page) instead of navigating.
  const headerCart = document.getElementById('cart-icon-bubble');
  if (headerCart) {
    headerCart.addEventListener('click', (e) => {
      // If we're in the editor or JS is disabled, allow default.
      if (!(window.VQCartDrawer && typeof window.VQCartDrawer.openAndRefresh === 'function')) return;
      e.preventDefault();
      e.stopPropagation();
      window.VQCartDrawer.openAndRefresh();
    }, true);
  }

  // ---------- reliable open on add-to-cart ----------
  // 2) Wrap fetch for /cart/add
  const _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function(input, init){
      const url = (typeof input === 'string') ? input : (input && input.url ? input.url : '');
      const isAdd = url && url.toLowerCase().includes('/cart/add');
      return _fetch.apply(this, arguments).then((res) => {
        if (isAdd && res && res.ok && !window.__stcPsCartTransaction) {
          // Open after customer-facing add completes. Internal Studio transactions stay in Studio.
          scheduleAddOpen();
        }
        return res;
      });
    };
  }

  // 3) Wrap XHR for /cart/add
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url){
    this.__vq_isAdd = !!(url && String(url).toLowerCase().includes('/cart/add'));
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(body){
    if (this.__vq_isAdd) {
      this.addEventListener('load', function(){
        if (this.status >= 200 && this.status < 300 && !window.__stcPsCartTransaction) {
          scheduleAddOpen();
        }
      });
    }
    return _send.apply(this, arguments);
  };



  const checkoutLink=qs('[data-vq-checkout]',drawer);
  const resetDrawerCheckoutState=()=>{
    if(!checkoutLink) return;
    checkoutLink.textContent=checkoutLink.dataset.vqOriginalText || 'Checkout';
    delete checkoutLink.dataset.vqFinalizing;
    drawer.classList.remove('vqcd--busy');
  };
  if(checkoutLink){
    checkoutLink.dataset.vqOriginalText=checkoutLink.textContent.trim() || 'Checkout';
    checkoutLink.addEventListener('click',async(event)=>{
      if(checkoutLink.getAttribute('aria-disabled')==='true'){
        event.preventDefault();
        return;
      }
      event.preventDefault();
      if(checkoutLink.dataset.vqFinalizing==='true') return;
      checkoutLink.dataset.vqFinalizing='true';
      checkoutLink.textContent='Preparing checkout…';
      drawer.classList.add('vqcd--busy');
      try{
        await finalizeCartMetadataForCheckout();
        window.location.assign('/checkout');
      }catch(error){
        console.error('[VQ] Checkout metadata cleanup failed',error);
        setCartMessage('We could not prepare your order for checkout. Please try again.');
        resetDrawerCheckoutState();
      }
    });
  }

  window.addEventListener('pageshow',()=>{
    resetDrawerCheckoutState();
    if(drawer.getAttribute('data-open')==='true'){
      refresh().catch(error=>console.error('[VQ] Shopping List refresh after page restore failed',error));
    }
  });

})();


